import { z } from 'zod'

export const UserRole = z.enum(['admin', 'member'])
export type UserRole = z.infer<typeof UserRole>

/** Rendered on the quote header. Every field optional — a sole trader has no VAT id. */
export const CompanyDetailsSchema = z.object({
  name: z.string().max(200).optional(),
  address: z.string().max(500).optional(),
  vat_id: z.string().max(60).optional(),
  email: z.string().max(200).optional(),
  phone: z.string().max(60).optional(),
  website: z.string().max(200).optional(),
  /** Hint passed to the model so quotes come out in the org's language. */
  language: z.string().max(40).optional(),
})
export type CompanyDetails = z.infer<typeof CompanyDetailsSchema>

export const OrgSettingsSchema = z.object({
  organization_id: z.string().uuid(),
  tasks_enabled: z.boolean(),
  email_enabled: z.boolean(),
  quoter_enabled: z.boolean(),
  default_currency: z.string().length(3),
  default_tax_rate: z.number().min(0).max(1),
  quote_valid_days: z.number().int().min(1).max(365),
  company_details: CompanyDetailsSchema.passthrough(),
})
export type OrgSettings = z.infer<typeof OrgSettingsSchema>

/** Subscription states that grant access to the app. */
export const ACTIVE_SUBSCRIPTION_STATUSES = new Set(['active', 'trialing'])

/** States where the fix is "update your card" in the Stripe portal, not a new
 *  checkout — a second checkout would open a second subscription. */
export const RECOVERABLE_SUBSCRIPTION_STATUSES = new Set(['past_due', 'unpaid', 'incomplete'])
